<template>
  <main>
    <div class="container">

      <section class="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">

              <div class="d-flex justify-content-center py-4">
                <router-link to="/" class="logo d-flex align-items-center w-auto">
                  <img src="assets/img/logo.png" alt="">
                  <span class="d-none d-lg-block">FinPlan</span>
                </router-link>
              </div>

              <div class="card mb-3">

                <div class="card-body">

                  <div class="pt-4 pb-2">
                    <h5 class="card-title text-center pb-0 fs-4">Регистрация</h5>
                    <p class="text-center small">{{ description }}</p>

                    <p class="text-center small" v-if="successFinish">
                      Email подтверждён. Теперь вы можете <router-link to="/auth">войти</router-link>.
                    </p>
                  </div>

                  <form v-if="regForm" @submit.prevent="onSubmitReg" class="row g-3">

                    <div class="col-12">
                      <label for="email" class="form-label">Email</label>
                      <div class="input-group has-validation">
                        <input type="text" name="username" v-model="email" class="form-control" id="email" required>
                      </div>
                    </div>

                    <div class="col-12">
                      <label for="password" class="form-label">Пароль</label>
                      <input v-model="password" type="password" name="password" class="form-control" id="password" required>
                    </div>

                    <div class="col-12">
                      <label for="password2" class="form-label">Пароль</label>
                      <input v-model="password2" type="password" name="password2" class="form-control" id="password2" required>
                    </div>

                    <div v-if="error" class="invalid-feedback" style="display: block" v-html="error"></div>
                    <div class="col-12">
                      <button class="btn btn-primary w-100" :disabled="loading" type="submit">
                        <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Регистрация
                      </button>
                    </div>
                  </form>

                  <ConfirmForm v-if="confirmForm"
                               :email="email"
                               :show-email="false"
                               @onSuccess="onSuccess"
                  />
                </div>
              </div>

            </div>
          </div>
        </div>

      </section>

    </div>
  </main>
</template>

<script setup>
import {nextTick, ref, watch} from 'vue';
import { usePersonal } from '@/features/personal/composables/usePersonal';
import { useRouter } from 'vue-router';
import ConfirmForm from "@/features/personal/components/ConfirmForm.vue";

const email = ref('');
const password = ref('');
const password2 = ref('');
const description = ref('Заполните форму');
const regForm = ref(true);
const confirmForm = ref(false);
const error = ref('');
const success = ref(false);
const successFinish = ref(false);
const loading = ref(false);
const { register } = usePersonal();
const router = useRouter();

function showConfirm() {
  regForm.value = false;
  confirmForm.value = true;
}

async function onSubmitReg() {
  error.value = '';
  success.value = false;

  if (password.value !== password2.value) {
    error.value = 'Пароли не совпадают';
    return;
  }

  loading.value = true;
  try {
    await register(email.value, password.value);
    regForm.value = false;
    confirmForm.value = true;
    description.value = "Введите проверочный код";
  } catch (e) {
    switch (e.code) {
      case 'email_not_confirmed':
        error.value = 'Этот email уже зарегистрирован, но не подтвержден, можете его <a href="#" id="confirm-link">подтвердить</a>';
        break;
      case 'email_exists':
        error.value = 'Этот email уже зарегистрирован';
        break;
      default:
        if (e.details) {
          e.details.forEach(function (err)  {
            if (err.code === 'invalid_password') {
              error.value = 'Пароль должен содержать мин одну цифру, одну букву и иметь длину более 8 символов';
            }
          });
        } else {
          error.value = 'Ошибка регистрации';
        }
        break;
    }
  } finally {
    loading.value = false;
  }
}

function onSuccess() {
  regForm.value = false;
  confirmForm.value = false;
  successFinish.value = true;
  description.value = "Спасибо за регистрацию!";
}

watch(error, async () => {
  await nextTick();
  const link = document.querySelector("#confirm-link");
  if (link) {
    link.addEventListener("click", showConfirm);
  }
});

</script>
